import { compact } from 'lodash';

import { countEmissionStats } from '@/lib/models/emissions/utils/count-emissions-stats';
import { mergeEmissionStats } from '@/lib/models/emissions/utils/merge-emission-stats';
import { RouteModel } from '@/lib/models/route/types';
import { EmissionStats } from '@/types';

export const calcE2eRouteEmissionsStats = (routes: RouteModel[]): EmissionStats | undefined => {
  const stats = compact(
    routes.map((route) => {
      const routeEmissionStats = compact([route.mainOptionEmissions, route.start?.emissions, route.end?.emissions]);
      return countEmissionStats(routeEmissionStats);
    }),
  );
  return mergeEmissionStats(stats);
};

export const calcRouteModeEmissionsStats = (routes: RouteModel[]): EmissionStats | undefined => {
  const stats = compact(routes.map((route) => route.mainOptionEmissions));
  return mergeEmissionStats(stats);
};
